import { Injectable } from '@angular/core';
import { horizontalBarData } from './horizontal-bar-interface'
import * as _ from 'lodash';
import * as title from '../../config/title';
import * as legend from '../../config/legend'
import * as series from '../../config/series'
import * as toolbox from '../../config/toolbox'
import * as tooltip from '../../config/tootip'
import * as xAxis from '../../config/xAxis'
import * as yAxis from '../../config/yAxis'
import * as color from '../../config/colors';
import * as brush from '../../config/brush'
import * as datazoom from '../../config/datazoom';
import * as backgroundColor from '../../config/backgroundColor';
import * as textStyle from '../../config/textStyle';
import { CommonService } from '../../service/common.service';
import { axisLabelRotate } from './horizontal-bar-interface'
import { legendPosition } from './horizontal-bar-interface';
import { ECharts } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class HorizontalBarService {

  constructor(
    private commonService: CommonService
  ) { }

  getHorizontalBarDefaultOption() {
    let style = this.commonService.changeFontSize();

    let option = {
      color: color.defaultColors,
      title: title.getBottomTitle(style),
      backgroundColor: backgroundColor.backgroundColor,
      grid: style.horizontalInterval,
      legend: legend.getLegendBottomScroll(style),
      // toolbox: toolbox.getToolboxBasicMenu(),
      tooltip: tooltip.getCommonTooltipOfAxis(),
      xAxis: xAxis.getValueXAxis(style),
      yAxis: yAxis.getCategoryYAxis(style),
      series: series.getBarChartSeries(style),
      textStyle: textStyle.getTextStyle()
    }
    return option;
  }
  // 更改toolbox显示状态
  // changeToolboxShow(chartOptions, show: boolean) {
  //    chartOptions.toolbox.show = show
  // }
  // 更改图例显示状态
  changeLegendShow(chartOptions, show: boolean) {
    chartOptions.legend.show = show
  }
  // 更改数据
  changeChartData(chartOptions, data, tooltipUnit: string = "", isDarkMode: boolean = false,labelUnitSwitch: boolean = true) {
    let style = this.commonService.changeFontSize();

    if (data) {
      chartOptions.yAxis[0].data = data.yData;
    }
    chartOptions.series = series.getBarChartSeries(style, data, tooltipUnit, labelUnitSwitch)
    this.openDarkMode(chartOptions, isDarkMode)
  }
  // 更改tooltip
  changeTooltip(chartOpt, tooltipUnit: string | string[]) {
    chartOpt.tooltip = tooltip.getCommonTooltipOfAxis(tooltipUnit)
  }
  // 更改XAxisName
  changeXAxisName(chartOpt, xAxisName: string) {
    chartOpt.xAxis[0].name = xAxisName;
  }
  // 更改yAxisName
  changeYAxisName(chartOpt, yAxisName: string) {
    chartOpt.yAxis[0].name = yAxisName;
  }
  // 更改yAxisNameGap
  changeYAxisNameGap(chartOpt, yAxisNameGap: number) {
    chartOpt.yAxis[0].nameGap = yAxisNameGap;
  }
  // x轴label的旋转
  changeXAxisLabelRotate(chartOpt, xAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.xAxis[0].axisLabel.rotate = rotate;
    chartOpt.xAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }
  // y轴label的选装
  changeYAxisLabelRotate(chartOpt, yAxisLabelRotate: axisLabelRotate) {
    let rotate = 0;
    switch (yAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    chartOpt.yAxis[0].axisLabel.rotate = rotate;
    chartOpt.yAxis[0].axisLabel.formatter = (value: string): string => {
      let valueText = '';
      if (value.length > 5) {
        valueText = value.substring(0, 5) + '...'
      } else {
        valueText = value
      }
      return valueText;
    }
  }

  setInterval(chartOpt, interval: number) {
    chartOpt.yAxis[0].axisLabel.interval = interval;
  }
  // 顶部图例改变
  topLegendChange(legendData: any[], optionInit: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }
  // 设置图例位置
  setLegendPosition(option, legendPosition: legendPosition) {
    let style = this.commonService.changeFontSize();
    if (legendPosition === 'top') {
      option.grid = style.horizontalTopLegendGrid;
      option.legend = legend.getTopLegend(style);
    } else if (legendPosition === 'none') {
      option.grid = style.horizontalNoLegendGrid;
      option.legend = legend.getLegendNotShow(style);
    } else if (legendPosition === 'right') {
      option.grid = style.rightLegendGrid;
      option.legend = legend.getLegendRightScroll(style);
    } else {
      option.grid = style.horizontalInterval;
      option.legend = legend.getLegendBottomScroll(style);
    }

  }

  // 更改图背景色
  changeBackground(option, chartBackground) {
    if (chartBackground) {
      option.backgroundColor = chartBackground;
    } else {
      option.backgroundColor = 'transparent';
    }
  }

  openDarkMode(chartOption, darkMode) {
    if (darkMode) {
      chartOption.series.forEach(element => {
        element.label.color = color.darkModeTextColor;
      });
    }
  }

  changeChartColors(chartOption, chartColors) {
    chartOption.color = chartColors;
  }

  changeTitleOption(chartOption, chartTitle, isSmallMode, legendPosition) {
    let style = this.commonService.changeFontSize();
    if (chartTitle == false) {
      return;
    }
    if (isSmallMode) {
      switch (legendPosition) {
        case 'bottom':
          chartOption.grid = style.horizontalSamllInterval;
          break;
        case 'top':
          chartOption.grid = style.horizontalSmallTopLegendGrid;
          break;
        case 'right':
          chartOption.grid = style.smallRightLegendGrid;
          break;
        case 'none':
          chartOption.grid = style.horizontalSmallNoLegendGrid;
          break;
        default:
          chartOption.grid = style.horizontalSamllInterval;
          break;
      }
    } else {
      switch (legendPosition) {
        case 'bottom':
          chartOption.grid = style.horizontalInterval;
          break;
        case 'top':
          chartOption.grid = style.horizontalTopLegendGrid;
          break;
        case 'right':
          chartOption.grid = style.rightLegendGrid;
          break;
        case 'none':
          chartOption.grid = style.horizontalNoLegendGrid;
          break;
        default:
          chartOption.grid = style.horizontalInterval;
          break;
      }
    }
    chartOption.title = title.getBottomTitle(style, true, chartTitle);
  }

  setXAxisMin(chartOption, xAxisMin: number) {
    chartOption.xAxis[0].min = xAxisMin
  }

  setXAxisMax(chartOption, xAxisMax: number) {
    chartOption.xAxis[0].max = xAxisMax
  }

  setXAxisInterval(chartOption, xAxisInterval: number) {
    chartOption.xAxis[0].interval = xAxisInterval;
  }

  setLabelUnitSwitch(chartOption, labelUnitSwitch: boolean) {
    if (chartOption.hasOwnProperty('series') && chartOption.series instanceof Array) {
      chartOption.series.forEach(element => {
        if (labelUnitSwitch == false) {
          element.label.formatter = '{c}'
        }
      });

    }
  }
}
